// src/pages/User/Suspended.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Suspended() {
  const navigate = useNavigate();

  return (
    <div className="suspended-wrapper">
      <div className="suspended-box">
        <div className="suspended-icon">⛔</div>
        <h1 className="suspended-title">Account Suspended</h1>
        <p className="suspended-text">
          আপনার অ্যাকাউন্ট বর্তমানে <strong>Suspended</strong> করা হয়েছে।  
          দয়া করে অ্যাডমিনের সাথে যোগাযোগ করুন।
        </p>
        <button className="suspended-btn" onClick={() => navigate("/")}>
          Go to Home
        </button>
      </div>

      {/* --- CSS --- */}
      <style>{`
        .suspended-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: linear-gradient(135deg, #ff4d4d, #990000);
          font-family: 'Poppins', sans-serif;
          color: #fff;
          animation: bgPulse 6s ease-in-out infinite alternate;
        }

        @keyframes bgPulse {
          0% { background: linear-gradient(135deg, #ff4d4d, #990000); }
          50% { background: linear-gradient(135deg, #ff8080, #660000); }
          100% { background: linear-gradient(135deg, #ff4d4d, #990000); }
        }

        .suspended-box {
          text-align: center;
          background: rgba(0,0,0,0.5);
          padding: 40px 60px;
          border-radius: 16px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.4);
          transform: scale(0);
          animation: zoomIn 0.8s forwards;
        }

        @keyframes zoomIn {
          to { transform: scale(1); }
        }

        .suspended-icon {
          font-size: 80px;
          margin-bottom: 20px;
          animation: shake 1s infinite;
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-10px); }
          40% { transform: translateX(10px); }
          60% { transform: translateX(-10px); }
          80% { transform: translateX(10px); }
        }

        .suspended-title {
          font-size: 36px;
          font-weight: 700;
          margin-bottom: 16px;
        }

        .suspended-text {
          font-size: 18px;
          margin-bottom: 30px;
          line-height: 1.5;
        }

        .suspended-btn {
          padding: 12px 28px;
          font-size: 18px;
          font-weight: 600;
          border: none;
          border-radius: 10px;
          background: #22c55e;
          color: #000;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .suspended-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 8px 20px rgba(0,0,0,0.4);
        }

        @media (max-width: 600px) {
          .suspended-box {
            padding: 30px 20px;
          }
          .suspended-title {
            font-size: 28px;
          }
          .suspended-text {
            font-size: 16px;
          }
          .suspended-icon {
            font-size: 60px;
          }
          .suspended-btn {
            font-size: 16px;
            padding: 10px 20px;
          }
        }
      `}</style>
    </div>
  );
}